import { createBrowserRouter, type RouteObject } from "react-router";
import App from "./App";
import { Home } from "./pages/Home/Home";
import { About } from "./pages/About";
import { Partners } from "./pages/Partners";
import { Events } from "./pages/Events";
import { EventDetail } from "./pages/EventDetail";
import { News } from "./pages/News";
import { NewsDetail } from "./pages/NewsDetail";
import { Membership } from "./pages/Membership";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: 'about',
                element: <About />,
            },
            {
                path: 'partners',
                element: <Partners />,
            },
            {
                path: 'events',
                element: <Events />,
            },
            {
                path: 'events/:slug',
                element: <EventDetail />,
            },
            {
                path: 'news',
                element: <News />,
            },
            {
                path: 'news/:slug',
                element: <NewsDetail />,
            },
            {
                path: 'membership',
                element: <Membership />,
            },
            {
                path: 'contact',
                element: <Contact />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
];

export const router = createBrowserRouter(routes);
